import authRules from '../authRules';

const editStatus = (user) => {
  const { status } = user.securityLevels;
  if (status >= authRules.editStatus.status) {
      return true;
  } else {
      return false;
    }
  }


export default editStatus;



// WEBPACK FOOTER //
// ./src/AuthLogic/rules/editStatus.js